import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CerrarDetalle } from "../../../helpers/controlSidebarDetalle";

import { useUnidades } from "../../../hooks/test/useUnidades";

import { SocketContext } from "../../../context/SocketContext";
import Swal from "sweetalert2";
import { Spinner } from "../../Spinner";

export const FormatoDetalleSalida = ({ unidad, viaje }) => {
  const [operador, setOperador] = useState([]);
  const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
  const [tripulacion, setTripulacion] = useState([]);
  const [loading, setLoading] = useState(false);

  const { socket } = useContext(SocketContext);

  const {
    getTiendasViaje,
    getTripulacionViaje,
    getOperadorViaje,
    putViajeStatusV2,
  } = useUnidades();

  useEffect(() => {
    if (!viaje.viaje_id) return;
    setLoading(true);
    getInfo(viaje.viaje_id);
    setLoading(false);
  }, [viaje]);

  const getInfo = async (viaje_id) => {
    let resp = await getTiendasViaje(viaje_id);
    if (resp.ok) setTiendasSeleccionadas(resp.rutas);

    resp = await getTripulacionViaje(viaje_id);
    if (resp.ok) setTripulacion(resp.tripulantes);

    resp = await getOperadorViaje(viaje_id);

    if (resp.ok) setOperador({ ...resp });
  };

  const viajeCancelado = async () => {
    let resp = await putViajeStatusV2(viaje.viaje_id, 9);
    if (!resp.ok)
      return Swal.fire({
        title: "No se pudo cancelar el viaje",
        text: resp.msg,
        icon: "error",
      });
    Swal.fire({
      title: "Unidad liberada",
      text: "La unidad ha sido liberada",
      icon: "success",
    });

    socket.emit("traer-unidades-en-ruta_", { idNegocio: unidad.negocio_id});

    CerrarDetalle();
  };

  return (
    <>
      {loading && <Spinner />}

      <div
        className="card display-oculto animated fadeInRight position-absolute top-0 end-0"
        id="contenedorDetalle"
      >
        <div className="card-header" id="card-header">
          SALIDA PROGRAMADA
          <i className="icono-cerrar">
            <FontAwesomeIcon
              onClick={() => {
                CerrarDetalle();
              }}
              icon={faXmark}
            />
          </i>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <b>Negocio</b>
            </div>
            <div className="col">
              {unidad.negocio ? unidad.negocio.negocio_nombre : ""}
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col">
              <b>Cedis</b>
            </div>
            <div className="col">
              {unidad.cedi ? unidad.cedi.nombre_cedis : "SIN CEDIS"}
              {unidad.spot && (
                <b className="text-warning mt-n4">
                  (SPOT {unidad.nombre_transportadora})
                </b>
              )}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <b>Eco</b>
            </div>
            <div className="col">{unidad.unidad_numero}</div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <b>Estatus</b>
            </div>
            <div className="col">
              {unidad.status ? unidad.status.nombre : ""}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <b>Destinos</b>
            </div>
            <div className="col">
              <ol>
                {tiendasSeleccionadas.length > 0
                  ? tiendasSeleccionadas.map((objTienda) => {
                      const { tienda } = objTienda;
                      const { tienda_id, tienda_nombre } = tienda;

                      return <li key={tienda_id}>{tienda_nombre}</li>;
                    })
                  : "No hay destinos seleccionados en este viaje"}
              </ol>
            </div>
          </div>
          <hr />
          <div className="row">
            <div className="col">
              <b>Operador</b>
            </div>

            <div className="col">
              {operador ? operador.nombre_completo : ""}
              <br />
            </div>
          </div>

          <div className="row">
            <div className="col">
              <b>Telefono</b>
            </div>
            <div className="col">
              <a href={`tel:+52${operador.telefono}`} className="text-success">
                {operador.telefono}
              </a>
            </div>
          </div>
          <hr />
          {tripulacion.length > 0 ? (
            <>
              <div className="row">
                <div className="col">
                  <b>Tripulación</b>
                </div>
                <div className="col">
                  {tripulacion.map((tripulante) => {
                    return (
                      <div key={tripulante.tripulante.tripulante_id}>
                        <label>{tripulante.tripulante.nombre_completo}</label>
                        <label>
                          <a
                            href={`tel:+52${tripulante.tripulante.telefono}`}
                            className="text-success"
                          >
                            {tripulante.tripulante.telefono}
                          </a>
                        </label>
                      </div>
                    );
                  })}
                </div>
              </div>
            </>
          ) : (
            <div className="row">
              <div className="col">
                <b>Tripulación</b>
              </div>
              <div className="col">SIN TRIPULACIÓN</div>
            </div>
          )}
          <hr />

          <div className="row">
            <div className="col">
              <b>Fecha de salida</b>
            </div>
            <div className="col">
              {viaje.fecha_hora_salida &&
                viaje.fecha_hora_salida.substring(0, 10)}
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col">
              <b>Hora de salida</b>
            </div>
            <div className="col">
              {viaje.fecha_hora_salida &&
                viaje.fecha_hora_salida.substring(11, 16)}
            </div>
          </div>
          <hr />
          <button onClick={viajeCancelado} className="btn btn-yellow btn-block">
            <FontAwesomeIcon icon={faTrash} /> cancelar Viaje
          </button>
        </div>

        <br />
      </div>
    </>
  );
};
